import React from "react";

const LogoMini = () => {
    return (
        <img src="/logo/logomini.svg" className="logo-mini img-fluid" alt="VehicleInfo - RC"/>
     );
};

export default LogoMini;